// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/vercel/path0/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/vercel/path0/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import FileTextOutlined from '/vercel/path0/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/@ant-design/icons/es/icons/FileTextOutlined';
export default { SmileOutlined, CrownOutlined, FileTextOutlined };
